import { render, staticRenderFns } from "./LabelLayoutEditor.vue?vue&type=template&id=52ba7f13&scoped=true"
import script from "./LabelLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./LabelLayoutEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba7f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ba7f13')) {
      api.createRecord('52ba7f13', component.options)
    } else {
      api.reload('52ba7f13', component.options)
    }
    module.hot.accept("./LabelLayoutEditor.vue?vue&type=template&id=52ba7f13&scoped=true", function () {
      api.rerender('52ba7f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/LabelLayoutEditor.vue"
export default component.exports